<script setup>
import bgCta from '@/assets/img/bg-smilepicture.png'
const props = defineProps({
    phoneNumber: {
        type: String,
        default: ''
    }
})
</script>

<template>
    <div class="content-wrapper">
        <section class="wrapper bg-black">
            <div class="container" style="padding: 3rem;">
                <div class="card rounded-4" :style="{
                    backgroundImage: `url(${bgCta})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }">
                    <div class="card-body cta-body p-md-10 p-xl-11">
                        <div class="row gx-lg-8 gx-xl-12 gy-10 justify-content-center text-center">
                            <div class="col">
                                <h3 class="display-4 mb-4 text-white">
                                    Have an idea or project in mind?<br>
                                    Let’s talk and explore how we can turn it into impactful visuals.
                                </h3>
                                <a :href="`https://wa.me/${phoneNumber}`" target="_blank" rel="noopener"
                                    class="btn btn-secondary rounded-pill" style="color: #820358;">
                                    Consultation Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style>
/* CTA RESPONSIVE HEIGHT FIX */
@media (max-width: 991.98px) {
    .cta-body {
        padding: 2rem 1.5rem !important;
        /* mobile + tablet lebih pendek */
    }

    .cta-body h3 {
        font-size: 1.4rem;
        line-height: 1.4;
    }
}

@media (max-width: 575.98px) {
    .cta-body {
        padding: 1.5rem 1.25rem !important;
        /* mobile makin rapet */
    }

    .cta-body h3 {
        font-size: 1.25rem;
    }
}
</style>
